import { createContext } from 'react';

interface ThemeContextProps {
    isDark?: boolean;
}

export const ThemeContext = createContext<ThemeContextProps>({});
